import React from 'react';

import moment from 'moment';

export const formFields = {


  campaignName: {
    key: 'campaignName',
    label: 'Campaign Name ',
    placeholder: '',
    displayLayout: 'col-sm-7',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'text',
  },

}


export const options = {
  columns: [
    { id: 1, name: 's.no', label: 'S.No.', sortable: true, type: 'number', expand: true, },
    { id: 2, name: 'advertiser', label: 'Advertiser Name', sortable: true, type: 'string' },
    { id: 3, name: 'recommendation', label: 'Current Recommendation', sortable: true, type: 'string'},
    // { id: 4, name: 'accountId', label: 'Account ID', sortable: true, type: 'number'},
    // { id: 5, name: 'currency', label: 'Currency', sortable: true, type: 'string'},
    // { id: 6, name: 'budgetName', label: 'Options', sortable: true, type: 'string', component: (row) => <div className='text-left'>{row.budgetName}</div> },
    // <div className='text-left'>{row.platforms.map((e, index) => e.platform)}</div>
    // { id: 6, name: 'startDate', label: 'Start Date', sortable: true, type: 'date', component: (row) => moment(row.startDate).format('DD-MMM-YY') },
    // // { id: 7, name: 'endDate', label: 'End Date', sortable: true, type: 'date', component: (row) => moment(row.endDate).format('DD-MMM-YY') },
    // { id: 7, name: 'endDate', label: 'End Date', sortable: true, type: 'date', component: (row) => row.endDate ? moment(row.endDate).format('DD-MMM-YY') : '' },
  ],
  // keyCol: 'ioNo',
  actions: [{
    type: 'edit',
    text: '',
    icon: 'mdi mdi-pencil',
    tooltip: 'Edit'
  }, {
    type: 'delete',
    text: '',
    icon: 'mdi mdi-delete',
    tooltip: 'Delete',
    confirmation: true,
    confirmationMessage: 'Kindly confirm the deletion of this record. This action cannot be undone.',
  }],
  recActive: true,
  status: {
    key: 'rec_active',
    active: '1',
    activeIcon: 'mdi mdi-checkbox-marked',
    inActiveIcon: 'mdi mdi-close-box',
    confirmation: true,
    activeConfirmationMessage: 'Kindly confirm the deactivation of this record.',
    inActiveConfirmationMessage: 'Please confirm if you wish to activate this record.',
  },
  actionsThead: false,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: false,
  defaultPagingParams: {
    pageSize: 25
  }
};

export const optionsHistory = {
  columns: [
    // {
    //   id: 1, name: 'date', label: 'Executed Date', sortable: true, type: 'date',
    //   // component: row => moment(row.date, 'YYYY-MM-DD').format('D-MMM-YY'),
    // },
    { id: 1, name: 's.no', label: 'S.No', sortable: true, type: 'string' , },
    { id: 2, name: 'name', label: 'Campaign Name', sortable: true, type: 'string' },
    { id: 3, name: 'platform', label: 'DSP Platform', sortable: true, type: 'string' },
  ],
  actions: [{
    type: 'existing RO',
    text: 'Map with Existing RO',
    icon: 'mdi mdi-pencil',
    tooltip: 'existing ro'
  }, {
    type: 'new ro',
    text: 'Create RO',
    icon: 'mdi mdi-pencil',
    tooltip: 'new ro'
  },
],
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: true,
  searchable: true,
  searchColumns: [
    // { key: 'date', func: (row) => moment(row.date, 'YYYY-MM-DD').format('D-MMM-YY') },
    { key: 'name' },
 
  ],
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'desc'
  },
  paging: true,
  defaultPagingParams: {
    pageSize: 25
  },
  // CSVDownload: {
  //   type: 'bidderReport',
  //   showCSVButton: true,
  //   buttonName: 'Download',
  //   saveFileName: 'bidderReport'
  // }

}